import React from "react";

const TVSLogo = ({logo}) => {
  return <div className="tvsIcon">
    <img src={logo} alt="The Vegan Society logo"/>
  </div>;
};

export default TVSLogo;
